import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CHAT_FORM_FIELD_NAMES } from 'features/chat/config';
import { ChatFormValues } from 'features/chat/config/types/ChatForm';
import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

export const usePersistChatMessageText = () => {
  const methods = useFormContext<ChatFormValues>();
  const { chatId } = useChatInterlocutorContext();
  const chatMessageKey = `chatMessage_${chatId}`;

  useEffect(
    () => {
      const chatMessage = localStorage.getItem(chatMessageKey);

      if (chatMessage) {
        methods.setValue(CHAT_FORM_FIELD_NAMES.TEXT, chatMessage);
        localStorage.removeItem(chatMessageKey);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chatMessageKey]
  );

  useEffect(
    () => {
      return () => {
        const chatMessage = methods.getValues().text;

        chatMessage && localStorage.setItem(chatMessageKey, chatMessage);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
